module.exports = __webpack_public_path__ + "img/2.52d1d94a.png";